module.exports = __webpack_public_path__ + "img/skl-logo.ea972d52.jpg";